import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { updateDashboardTable } from '../../reducers';
import { Button, Table, Modal, Menu, Dropdown, Icon, Typography } from 'antd';
import axios from '~/axios';

const { Text } = Typography;
import moment from 'moment';

import NotificationButton from './NotificationButton';

class DashboardSubmissions extends Component {
    constructor(props) {
        super(props);
        this.showSendDialog = this.showSendDialog.bind(this);
        // this.updateDashboardTable = this.updateDashboardTable.bind(this);
        // this.handleRemoveSubmission = this.handleRemoveSubmission.bind(this);
    }

    /**
     * Shows the 'Confirm Notification' dialog.
     * @param {string} email - The email address of the new hire.
     * @param {number} submissionID - The ID of the new hire's submission.
     */
    showSendDialog(email, submissionID, type) {
        this.props.showSendDialog(email, submissionID, type);
    }

    /**
     * Sets a submission's 'registered' column to True
     * @param {number} submissionID - The ID of the new hire's submission.
     */
    handleRegister(submissionID) {
        const component = this;
        Modal.confirm({
            title: 'Has this employee been registered on LearningHub?',
            content: "Pressing 'Continue' will mark this employee as 'Registered on LearningHub' in ROAR.",
            okText: 'Continue',
            onOk() {
                axios.patch('/api/submissions/' + submissionID, {
                    'registered': true
                }).then(response => {
                    console.log(response)
                    if (response.data.registered) {
                        // call the parent component's handler
                        component.props.handleRegister(submissionID);
                    }
                }).catch(error => {
                    // TODO add utility function for displaying error modal
                    console.log(error)
                });
            },
            onCancel() {
            },
        });
    }

    /**
     * Sets a submission's 'registered' column to False
     * @param {number} submissionID - The ID of the new hire's submission.
     */
    handleUnregister(submissionID) {
        const component = this;

        Modal.confirm({
            title: 'Set employee as not registered?',
            content: "Pressing 'Continue' will mark this employee as not registered in ROAR.",
            okText: 'Continue',
            onOk() {
                axios.patch('/api/submissions/' + submissionID, {
                    'registered': false
                }).then(response => {
                    console.log(response)
                    if (!response.data.registered) {
                        // call the parent component's handler
                        component.props.handleUnregister(submissionID);
                    }
                }).catch(error => {
                    // TODO add utility function for displaying error modal
                    console.log(error)
                });
            },
            onCancel() {
            },
        });


    }

    /**
     * Shows a modal asking to confirm session deletion.
     * @param {object} data - The submission's data.
     */
    handleRemoveSubmission(submissionID) {
        const component = this;
        Modal.confirm({
            title: 'Delete session?',
            content: 'Are you sure you want to delete this submission? This action cannot be undone.',
            okText: 'Delete Session',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk() {
                console.log(component.props);
                // Deletes the selected session.
                axios.delete('/api/submissions/' + submissionID).then(response => {
                    console.log(response)
                    component.props.handleRemoveSubmission(submissionID);
                }).catch(error => {
                    console.error(error)
                });
            },
            onCancel() {
            },
        });
    }

    render() {

        // const notificationMenu = submission => (
        //   <Menu >
        //     <Menu.Item key="1" onClick={this.showSendDialog.bind(this, submission.email, submission.submissionID, 'full')}>
        //       {/* <Icon type="user" /> */}
        //       Full Notification
        //     </Menu.Item>
        //     <Menu.Item key="2" onClick={this.showSendDialog.bind(this, submission.email, submission.submissionID, 'minimal')}>
        //       {/* <Icon type="user" /> */}
        //       Minimal Notification
        //     </Menu.Item>
        //   </Menu>
        // );

        const columns = [
            {
                title: 'Name',
                dataIndex: 'fullName',
                key: 'name',
                render: (data, record) => <Link to={ { pathname: "/schedule/" + record.submissionID } }><Text underline
                                                                                                              strong>{ record.fullName }</Text></Link>,
                sorter: true
            }, {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                sorter: true
            }, {
                title: 'Submitted',
                dataIndex: 'created_at',
                key: 'date',
                render: (data, record) => <span>{ moment(record.created_at).format("MMM Do YYYY") }</span>,
                sorter: true
            }, {
                title: 'First Session',
                dataIndex: 'firstSession',
                key: 'month',
                render: (data, record) => <span>{ moment(record.firstSessionDate).format('MMMM Do YYYY') }</span>,
                sorter: false
            },
            // {
            //   title: 'Site',
            //   key: 'site',
            //   dataIndex: 'workSite',
            //   sorter: (a, b) => a.workSite.localeCompare(b.workSite)
            // },
            {
                title: 'Day 1 Site',
                key: 'location',
                dataIndex: 'dayOneLocation',
                sorter: false
            },
            // {
            //   title: 'Schedule',
            //   key: 'schedule',
            //   dataIndex: 'submissionID',
            //   render: (submissionID) => <Link to={{ pathname: "/schedule/" + submissionID }}>View schedule</Link>
            // },
            {
                title: 'Notification',
                key: 'notification',
                //         if (submission.notified) {
                //   return <Dropdown.Button overlay={notificationMenu(submission)} onClick={this.showSendDialog.bind(this, submission.email, submission.submissionID, 'full')} type="primary" style={{ background: "#52C41A", borderColor: "#52C41A" }}><Icon type="check" /> Notified</Dropdown.Button>
                // } else {
                //   return <Dropdown.Button overlay={notificationMenu(submission)} onClick={this.showSendDialog.bind(this, submission.email, submission.submissionID, 'full')}><Icon type="mail" /> Send</Dropdown.Button>
                // }
                render: (submission) => <NotificationButton submission={ submission }
                                                            showSendDialog={ this.showSendDialog }/>,
                sorter: false
            }, {
                title: 'Registered',
                key: 'registered',
                render: (submission) => {
                    if (submission.registered) {
                        // return <Alert message="Registered" type="success" showIcon />;
                        return <Button block onClick={ this.handleUnregister.bind(this, submission.submissionID) }
                                       type="primary" icon="check">Registered</Button>
                    } else {
                        return <Button block
                                       onClick={ this.handleRegister.bind(this, submission.submissionID) }>Register</Button>
                    }
                },
                sorter: false
            },
            // {
            //   title: 'Delete',
            //   key: 'delete',
            //   render: (data, record) => <Button type="danger" onClick={this.deleteSubmission.bind(this, data, record)} icon="delete"/>
            // },
            {
                title: 'Actions',
                key: 'actions',
                // width: 50,
                render: (data, record) => {
                    const actionMenu = (
                        <Menu>
                            <Menu.Item key="0">
                                <Link to={ { pathname: "/schedule/" + record.submissionID } }>View schedule</Link>
                            </Menu.Item>
                            <Menu.Item key="1">
                                <Link to={ {
                                    pathname: '/registration',
                                    state: {
                                        submissionID: record.submissionID
                                    }
                                } }>Edit Schedule</Link>
                            </Menu.Item>
                            <Menu.Divider/>
                            <Menu.Item key="2" onClick={ this.handleRemoveSubmission.bind(this, record.submissionID) }
                                       icon="delete" type="danger">
                                <Icon type="delete"/>Delete
                            </Menu.Item>
                        </Menu>
                    );

                    return (
                        <Dropdown overlay={ actionMenu } trigger={ ['click'] }>
                            <a className="ant-dropdown-link dashboard-action" href="#">
                                <Icon type="more"/>
                            </a>
                        </Dropdown>
                    )
                }
            }

        ];

        return (
            <Table loading={ this.props.loading } columns={ columns } className="white-table"
                   dataSource={ this.props.data }
                   rowKey='submissionID'
                   pagination={ { pageSize: 15, current: this.props.dashboardPage, total: this.props.total } }
                   onChange={ (pagination, filters, sorter, extra) => this.props.updateDashboardTable(pagination.current, filters, sorter) }/>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
}

// connect the login form to redux
export default connect(mapStateToProps, { updateDashboardTable })(DashboardSubmissions);